// extracted by mini-css-extract-plugin
module.exports = {"logoWidth":"260px","logoHeight":"28px","navHeight":"120px"};